import React, { useState } from 'react'
import { FiEdit } from 'react-icons/fi'
import { RiDeleteBinLine } from 'react-icons/ri'
import { apiV1 } from '../../../utils/api'
import { PopUp, SelectField } from '../../Resources'
import TableV1 from '../../Resources/TableV1/TableV1'
import TitleContainer from '../../Resources/TitleContainer/TitleContainer'
import classes from './SubCategoryList.module.css'

export default function SubCategoryList(props) {
    const [newName, setNewName] = useState('')
    const [id, setId] = useState('')
    const [sl, setSl] = useState('')
    const [option, setOption] = useState('0')

    const handleEdit = () => {
        const url = `${apiV1}/categories/sub_category/${id}`
        const status = 'category updated'
        const method = 'PUT'
        props.handleClick(url, method, status)
    }
    const handleDelete = () => {
        const url = `${apiV1}/categories/sub_category/${id}`
        const url2 = `${apiV1}/categories/sub_sub_category/${id}`
        const status = 'sub category deleted'
        const status2 = 'Please remove the sub sub category of this sub category first!'
        const method = 'DELETE'
        props.handleClick(url, newName, method, status, url2, status2)
    }
    return (
        <div className={classes.wrapper}>
            <div className={classes.select}>
                <div>
                    <SelectField
                        search_by="-- Select category --"
                        searchable={true}
                        clearable={true}
                        options={props.categoryOption}
                        value={props.categorySelect}
                        selectOnChange={(e) => {
                            if (e) {
                                props.setCategorySelect(e)
                                props.setSubCategorySelect('')
                            } else {
                                props.setCategorySelect('')
                                props.setSubCategorySelect('')
                            }
                        }}
                    />
                </div>
            </div>
            <TitleContainer title={'Sub Category List'} isCount={true} count={props.subCategory?.length} />
            <TableV1>
                <thead>
                    <tr className={`${classes.tableRow}`}>
                        <th>Id</th>
                        <th>Category List</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>

                <tbody>
                    {props.subCategory &&
                        props.subCategory.map((data, index) => (
                            <tr className={classes.row} key={index}>
                                <td>{data.id}</td>
                                <td>
                                    {data.name}

                                    {props.clickEdit && sl === index && (
                                        <>
                                            {' -> '}
                                            <input
                                                className={classes.categoryInput}
                                                type="text"
                                                placeholder="Enter new name"
                                                value={newName}
                                                onChange={(e) => setNewName(e.target.value)}
                                            />
                                        </>
                                    )}
                                </td>
                                <td>
                                    {!props.clickEdit && (
                                        <FiEdit
                                            className={classes.icon}
                                            onClick={() => {
                                                props.setClickEdit(true)
                                                setId(data.id)
                                                setSl(index)
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    )}

                                    {props.clickEdit && sl === index && (
                                        <div className={classes.EditButton}>
                                            {newName && (
                                                <div
                                                    className={classes.save}
                                                    onClick={() => {
                                                        handleEdit()
                                                    }}>
                                                    Save
                                                </div>
                                            )}
                                            <div
                                                className={classes.cancel}
                                                onClick={() => {
                                                    props.setClickEdit(false)
                                                    setNewName('')
                                                }}>
                                                Cancel
                                            </div>
                                        </div>
                                    )}
                                </td>
                                <td>
                                    {
                                        <RiDeleteBinLine
                                            className={classes.iconDelete}
                                            onClick={() => {
                                                // setClickEdit(true)
                                                props.setActivePopUp(true)
                                                setId(data.id)
                                                setSl(index)
                                                setOption('2')
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    }
                                    {props.activePopUp && sl === index && option === '2' && (
                                        <PopUp
                                            setActivePopUp={props.setActivePopUp}
                                            btnClickPopUp={'2'}
                                            message={'Are you confirm?'}
                                            handleDelete={handleDelete}
                                            categoryId={data.id}
                                        />
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </TableV1>
        </div>
    )
}
